import firebase from './firebaseBundle'

const getFirebaseJWTForCurrentUser = async () => {
  const firebaseJWT = await firebase.auth().currentUser.getIdToken()

  return firebaseJWT
}

export default getFirebaseJWTForCurrentUser
